import { Array } from '@common/Array/Array'

import type { TBrowser } from '../definitions'
import { EDGE_BROWSERS } from '../definitions'

/**
 * Edget használ a user.
 * @param browser - Browser típusa.
 */
export default function isEdge (browser: TBrowser): boolean {
  return Array.includes(EDGE_BROWSERS, browser)
}
